import React, { forwardRef, Ref, useEffect, useRef } from 'react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './App.css';

import ch from './cancer-hereditario.jpg'
import { Box, createTheme, Drawer, Grid, IconButton, Paper, responsiveFontSizes, ThemeProvider, Typography, useMediaQuery, useTheme, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ListIcon from '@mui/icons-material/List';
import BG_IMG from './MEnu.png'
import { TiposDeCancer } from './TiposDeCancer';
import { QueEsAndesGenomics } from './QueEsAG';
import { Contacto } from './Contacto';
import MapaConPuntos from './maps';
import { Clinicas } from './Clinicas'
import { Fundaciones } from './Fundaciones';
import { LaboratoriosDeSequenciacion } from './LabSeq';
import 'aos/dist/aos.css';
import Aos from 'aos'
import { LaboratoriosFarmaceuticos } from './LaboratoriosFarmaceuticos';

function CollapsedMenu() {
  const [open, setOpen] = React.useState(false);
  const [scrollState, setScrollState] = React.useState(false);
  window.addEventListener('scroll', (e) => {

    if (window.scrollY > 50) {
      setScrollState(true);
    }
    else {
      setScrollState(false);
    }
  });
  return (<div style={{ position: "fixed", width: "100vw", zIndex: 999, backgroundColor: scrollState ? "#373737" : "transparent" }}>
    <Grid container>
      <div style={{ display: "flex", flexDirection: "row", padding: "1rem", width: "100vw", justifyContent: "space-between", alignItems: "center" }}>
        <IconButton onClick={() => { setOpen(!open) }}>
          <MenuIcon style={{ color: "white" }} />
        </IconButton>
        <Grid>
          <Typography variant='h5' color='white' style={{ height: "100%" }}>
            AndesGenomics
          </Typography>
        </Grid>
        <img className="logo_effect" style={{ objectFit: "cover", borderRadius: "100%", marginRight: "1rem" }} width={"40px"} height={"40px"} src={ch} alt="" />

      </div>
    </Grid>
    <Drawer

      onClose={() => { setOpen(false) }} open={open}>
      <Box component="img" src={BG_IMG} style={{ objectFit: "cover" }} sx={{
        position: "absolute",
        width: "100%",
        height: "100vh"
      }}>

      </Box>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "1rem" }}>
          <ListIcon></ListIcon>
          <Typography variant='h6'>Menu</Typography>

        </div>
        <div style={{ padding: "1rem", display: "flex", flexDirection: "column", alignItems: "center" }}>

          <Button>Quienes somos</Button>
          <Button>Qué hacemos</Button>
          <Button>Afiliados</Button>
        </div>

      </div>
    </Drawer>
  </div>);
}
type HeaderInput =
  {
    name: string,
    ref: React.RefObject<HTMLDivElement | null>
  }
type References = HeaderInput[];

function Header({ references }: { references: References }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  const [scrollState, setScrollState] = React.useState(false);

  window.addEventListener('scroll', (e) => {
    if (window.scrollY > 50) {
      setScrollState(true);
    }
    else {
      setScrollState(false);
    }
  });
  if (matches) {
    return <Paper elevation={scrollState ? 4 : 0} square={true} className='flex-row-a' style={{
      width: "100dvw", position: "fixed", justifyContent: "space-between", zIndex: 999,

      backgroundColor: scrollState ? "#121212" : "transparent", boxShadow: scrollState ? '#ab47bc 1px 1px 15px' : 'none'
    }}>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: ".5rem" }}>
        <img className="logo_effect" style={{ objectFit: "cover", borderRadius: "100%", marginRight: "1rem", marginLeft: "1rem" }} width={"40px"} height={"40px"} src={ch} alt="" />

        <Typography variant='h5' color='white'>
          ANDES
        </Typography><Typography variant='h6' color='white'>Genomics</Typography>
      </div>

      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }} className='anim_banner_AG'>
        {
          references.map((value, index) => <Button
            onClick={() => value.ref.current?.scrollIntoView({behavior:'smooth'})}
            style={{ marginLeft: "1rem", color: "white", textTransform: 'uppercase' }}> {value.name} </Button>)
        }

        <div style={{ marginRight: "1rem" }}></div>
      </div>
    </Paper>
  }
  return <CollapsedMenu></CollapsedMenu>

}




const MiddleImage = forwardRef((props, ref) => {
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, [])

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up(716));
  const width = !matches ? "auto" : "100%"
  const height = !matches ? "100vh" : "100%"

  return <header style={{
    width: 'auto', height: '100vh',
    background: "linear-gradient(180deg, rgba(13, 29, 69, 0.6) 0%, rgba(99, 91, 255, 0) 92.07%)",
    display: "flex", flexDirection: "column", justifyContent: "center", color: "white",
    alignItems: "center", fontWeight: "600"
  }}>
    <Typography variant='h4' data-aos='zoom-in'>
      Especialistas en asesoramiento genético
    </Typography>
    <Button variant='contained' style={{ background: 'transparent', border: "solid 1px white", color: "white", marginTop: "1rem" }}>
      Contactanos
    </Button>
    <div className="video-container" style={{
      width: width, height: height,
      zIndex: -1,
      alignItems: "center", position: "fixed"
    }}>

      <video autoPlay loop muted playsInline className="video-bg" style={{
        minHeight: "100vh", minWidth: "100vw"
      }}>
        <source src="Video/v1.mp4" type="video/mp4" />
        Tu navegador no soporta video en HTML5.
      </video>
    </div></header>
});


function App() {

  const middleImageRef = React.useRef(null)
  const queEsAndesGenomicsRef = React.useRef(null)
  const tiposDeCancerRef = React.useRef(null)
  const labsRef = React.useRef(null)
  const clinicasRef = React.useRef(null)
  const fundacionesRef = React.useRef(null)
  const laboratoriosDeSequenciacionRef = React.useRef(null)
  const ayudaRef = React.useRef(null)
  const contactoRef = React.useRef(null)

  const referencesHeader: References = [
    { name: 'Cáncer', ref: tiposDeCancerRef },
    { name: 'Laboratorios', ref: labsRef },
    { name: 'Clínicas', ref: clinicasRef },
    { name: 'Fundaciones', ref: fundacionesRef },
    { name: 'Sequenciación', ref: laboratoriosDeSequenciacionRef },
    { name: 'Encuentra ayuda', ref: ayudaRef },
    { name: 'Contacto', ref: contactoRef },
    
  ]

  let darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#90caf9',
      },
    },
    typography:
    {
      fontFamily: "roboto"
    }
  });
  darkTheme = responsiveFontSizes(darkTheme)
  return (
    <ThemeProvider theme={darkTheme}>
      <div className="App">
        <Header references={referencesHeader}></Header>
        <MiddleImage ref={middleImageRef}></MiddleImage>
        <QueEsAndesGenomics ref={queEsAndesGenomicsRef} />
        <TiposDeCancer ref={tiposDeCancerRef} />
        <LaboratoriosFarmaceuticos ref={labsRef} />
        <Clinicas ref={clinicasRef} />
        <Fundaciones ref={fundacionesRef} />
        <LaboratoriosDeSequenciacion ref={laboratoriosDeSequenciacionRef} />
        <MapaConPuntos ref={ayudaRef} />
        <Contacto ref={contactoRef} />
      </div>
    </ThemeProvider>

  );
}
export default App;
